// extracted by css-extract-rspack-plugin
export default {"root":"i4gMK","visible":"DzXMp"};